<template>
  <a-config-provider :locale="locale">
    <div id="app" :class="[_isMobile() ? 'mobile' : '']">
      <loading />
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'
// import Vue from "vue";
// import { TENANT_ID } from "@/store/mutation-types";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import loading from './theme/wayi/components/loading'
export default {
  name: "App",
  mixins: [mixinDevice],
  components: {loading},
  data() {
    return {
      locale: zhCN,
      // tenantId: ''
    };
  },
  watch:{
    $route(to, from) {
    },
  },
  mounted() {},
  created() {
    // this.tenantId = Vue.ls.get(TENANT_ID)
    // console.log("租户：" + this.tenantId);
  },
  methods: {

  },
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  width: 100%;
  min-height: 100%;
}
.ant-avatar{
  //background-color:var(--primary-color)!important;
}
.ant-tabs-nav,.ant-tabs-tab-active,.ant-table-thead > tr > th{
  font-weight: 700!important;
}
</style>
